import * as React from "react";
import { Link } from "react-router-dom";
import CongratsCarImg from "../../common/components/congratsCarImg";
import HdfcHeader from "../../common/components/pageBlocks/hdfcHeader";
import commonContext, { AppContext } from "../../common/context/common";
import qs from "query-string";
import { leadType, offerType } from "../../app";
import { Utilities } from "../../common/utils/utilities";
import { Authorization } from "../../common/utils/authorization";
import { Zd10SecApis } from "../apis/zd10SecApis";

interface IProps {
    history: any;
    location: any;
}
interface IState {
    agree?: boolean;
}
export default class OfferDetails extends React.Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    offer: offerType;
    apis: Zd10SecApis;
    setLead: Function;
    setOffer: Function;
    utils: Utilities;
    base: string;
    authKeeper: Authorization;
    constructor(props: IProps) {
        super(props);
        this.state = {
            agree: false,
        };
    }
    async componentDidMount() {
        window.scrollTo(0, 0);
        this.apis = (this.context as AppContext).apis as Zd10SecApis;
        this.setLead = (this.context as AppContext).setLead;
        this.setOffer = (this.context as AppContext).setOffer;
        this.lead = (this.context as AppContext).lead as leadType;
        this.utils = (this.context as AppContext).utils as Utilities;
        this.authKeeper = (this.context as AppContext)
            .authKeeper as Authorization;
        if (this.authKeeper.authorization) {
            console.log("ssr is avaliable", this.context);
            let { offer } = this.context;
            if (Object.keys(offer || {}).length <= 0) {
                this.props.history.push("/error");
            } else {
                const emi = this.utils.getEmi(
                    offer?.interestRate,
                    offer?.loanAmt,
                    offer?.tenure
                );
                this.setOffer({ offer });
                this.setLead({
                    ...offer,
                    ...this.lead,
                    customerId: offer.customerId ? offer.customerId : "",
                    promoCode: offer.promoCode ? offer.promoCode : "",
                    emi,
                });
            }
        } else {
            const query = qs.parse(this.props.location.search);
            if (query.customerid) {
                this.lead.customerId = query.customerid;
            }
            if (query.promocode) {
                this.lead.promoCode = query.promocode;
            }
            const apiData = await this.apis.verifyPromoCodeAndGetDetails(
                this.lead
            );
            // if (apiData.error.error) {
            //     this.props.history.push("/error");
            // }
            // console.log("apiData", apiData);
            await this.authKeeper.setAuthorization(apiData?.result?.token);
            const offer = apiData?.result?.offer;
            const leads = apiData?.result?.lead;
            if (Object.keys(offer || {}).length <= 0) {
                this.props.history.push("/error");
            } else {
                const emi = this.utils.getEmi(
                    offer?.interestRate,
                    offer?.loanAmt,
                    offer?.tenure
                );
                this.setOffer({ offer });
                this.setLead({
                    ...offer,
                    ...leads,
                    customerId: offer.customerId ? offer.customerId : "",
                    promoCode: offer.promoCode ? offer.promoCode : "",
                    emi,
                });
            }
        }
    }

    handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            agree: !this.state.agree,
        });
    };
    handleSubmit = (e) => {
        e.preventDefault();
        if (this.state.agree) {
            this.props.history.push("/vehicle-details");
        }
    };
    render() {
        this.lead = (this.context as AppContext).lead as leadType;
        this.offer = (this.context as AppContext).offer as offerType;
        this.utils = (this.context as AppContext).utils as Utilities;

        return (
            <>
                <div className="wrapper">
                    <HdfcHeader />
                    <section className="congrats-wrap bg-sky-blue flex mt-72">
                        <div className="container mx-auto px-5">
                            <div className="congrats-screen">
                                <CongratsCarImg />
                                <div className="w-full">
                                    <h1 className="text-center font-42px openSans-Light mb-1">
                                        Congratulations
                                        <span className="openSans-Reg cust-name">
                                            {" "}
                                            {this.lead?.pdApplicantFirstName}
                                        </span>
                                        !
                                    </h1>
                                    <h2 className="text-center text-2xl md:text-2xl xl:text-4xl openSans-Light mb-3">
                                        You are eligible for a
                                        <span className="offer-car-name px-2 openSans-SemiBold">
                                            car loan
                                        </span>
                                        upto{" "}
                                        {this.lead.loanAmt ? (
                                            <>
                                                <span className="WebRupee">
                                                    Rs.
                                                </span>
                                                <span className="offer-car-amt px-2 openSans-SemiBold">
                                                    {this.utils.currencyFormat(
                                                        this.lead.loanAmt
                                                    )}
                                                </span>
                                            </>
                                        ) : (
                                            ""
                                        )}
                                    </h2>
                                </div>
                                <div className="congrats-offer-table max-w-md md:max-w-md flex flex-wrap justify-center mx-auto openSans-Reg my-8">
                                    <div className="my-1 w-4/12">
                                        <div className="congrats-offer-table-td w-full flex flex-wrap flex-col justify-start">
                                            <label className="congrats-offer-table-label text-left text-xs md:text-base lg:text-lg break-normal">
                                                EMI
                                            </label>
                                            <div className="congrats-offer-table-info text-left text-xl md:text-2xl lg:text-3xl break-normal">
                                                {this.lead.emi ? (
                                                    <>
                                                        <span className="WebRupee">
                                                            Rs.
                                                        </span>
                                                        <span className="congrats-offer-amt">
                                                            {this.utils.currencyFormat(
                                                                this.offer.emi
                                                                    ? this.offer
                                                                          .emi
                                                                    : this.lead
                                                                          .emi
                                                            )}
                                                        </span>
                                                    </>
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="my-1 w-4/12">
                                        <div className="congrats-offer-table-td w-full flex flex-wrap flex-col justify-start">
                                            <label className="congrats-offer-table-label text-left text-xs md:text-base lg:text-lg break-normal">
                                                Interest Rate
                                            </label>
                                            <div className="congrats-offer-table-info text-left text-xl md:text-2xl lg:text-3xl break-normal">
                                                <span className="congrats-offer-int">
                                                    {this.lead?.interestRate}%
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="my-1 w-4/12">
                                        <div className="congrats-offer-table-td w-full flex flex-wrap flex-col justify-start">
                                            <label className="congrats-offer-table-label text-left text-xs md:text-base lg:text-lg break-normal">
                                                Processing Fees
                                            </label>
                                            <div className="congrats-offer-table-info text-left text-xl md:text-2xl lg:text-3xl break-normal">
                                                {this.lead.processingFees ? (
                                                    <>
                                                        <span className="WebRupee">
                                                            Rs.
                                                        </span>
                                                        <span className="congrats-offer-processfee">
                                                            {this.utils.currencyFormat(
                                                                this.lead
                                                                    .processingFees
                                                            )}
                                                        </span>
                                                    </>
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p className="openSans-Reg congrats-screen-txt text-center text-xs md:text-base lg:text-lg my-4">
                                    Rate of Interest and EMI may vary as per the
                                    model/loan amount/tenure selected
                                </p>
                            </div>
                        </div>
                    </section>
                    <section className="congrats-confirm-wrap flex">
                        <div className="container mx-auto px-5">
                            <form onSubmit={(e) => this.handleSubmit(e)}>
                                <div className="block">
                                    <div className="mt-4">
                                        <div className="text-left md:text-center">
                                            <label className="custom-inputs inline-flex items-start md:items-center confirm-checkbox">
                                                <input
                                                    type="checkbox"
                                                    name="agree"
                                                    onChange={(e) =>
                                                        this.handleChange(e)
                                                    }
                                                />
                                                <span></span>
                                                <span className="ml-2 text-sm md:text-base lg:text-xl">
                                                    I authorise HDFC Bank and
                                                    its representatives to
                                                    contact me with reference to
                                                    my application
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-4 my-4 text-center">
                                    <button
                                        className="button-blue-bg hover:bg-blue-700 text-white py-2 px-4 rounded text-base lg:text-lg xl:text-xl openSans-SemiBold button-blue congrats-cofirm-applynow"
                                        title="Apply Now"
                                    >
                                        Apply Now
                                    </button>
                                </div>
                            </form>
                            <div className="mt-6 my-6 text-center">
                                <Link to="/higher-loan-apply-form">
                                    <a
                                        className="openSans-SemiBold high-loan-click no-underline hover:underline"
                                        title="I need a higher loan amount"
                                    >
                                        I need a higher loan amount
                                    </a>
                                </Link>
                            </div>
                        </div>
                    </section>
                </div>
            </>
        );
    }
}
